import { render, staticRenderFns } from "./AdminPartial.vue?vue&type=template&id=886ffecc&"
import script from "./AdminPartial.vue?vue&type=script&lang=js&"
export * from "./AdminPartial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports